import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'

const Banner = ({banner}) => {
  const { t, i18n } = useTranslation()

  return (
    <section className="cfn-home-banner">
      <div class="home-banner-section">
        <div class="banner-inner-content">
           {banner.img.map((item, index) => (
          <img src={item}/>))}
        </div>
        <div className="cfn-banner-content">
          <img src={banner.logo} alt="One2One Logo"/>
          <h1>{banner.title}</h1>
        </div>
      </div>
    </section>
  );
};

export default Banner;